// Unpublished Work © 2024 Deere & Company.

import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import { Typography } from "@mui/material";

export interface ActiveDealerAccountProps {
  accountId: string;
  dealerName: string;
}

const ActiveDealerAccount = ({
  accountId,
  dealerName,
}: ActiveDealerAccountProps) => (
  <>
    <AccountBalanceIcon data-testid="account-icon" sx={{ width: "16px" }} />
    <Typography
      data-testid="dealer-account-id"
      sx={{ fontWeight: 400, fontSize: "12px" }}
    >
      {accountId}
    </Typography>
    <Typography
      data-testid="account-name"
      sx={{ fontWeight: 400, fontSize: "12px" }}
    >
      {dealerName}
    </Typography>
  </>
);

export default ActiveDealerAccount;
